<app-table-generator
    style="margin-top: 8px"
    *ngIf="tableInput"
    [tableInput]="tableInput"
    [widgetRef]="widgetRef"
></app-table-generator>
